import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-prepick-create',
  templateUrl: './prepick-create.component.html',
  styleUrls: ['./prepick-create.component.css']
})
export class PrepickCreateComponent implements OnInit {
    argType;

    argValue;

    private setting?: Setting;

    public itemsListPrePick: Item[] = [];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1052, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadPrePick() {
        if (!this.setting) return;

        return this.itemsListPrePick = await this.datatask.Post(1053, this.setting);
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.itemsListPrePick) {
            const response = (await this.datatask.Post(1054, {
                argtype: this.argType,
                argvalue: this.argValue,
                stocklocation_keyno: event.item.item_id
            }))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            } else {
                this.stateService.back();
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadPrePick();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id: string;
    argtype: string;
    argvalue: string;
}
